import { render } from "./AddEditManualRate.vue?vue&type=template&id=5dec89da&scoped=true"
import script from "./AddEditManualRate.vue?vue&type=script&lang=js"
export * from "./AddEditManualRate.vue?vue&type=script&lang=js"

import "./AddEditManualRate.vue?vue&type=style&index=0&id=5dec89da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dec89da"]])

export default __exports__